import { buildColorPropsSDKFactoryCreator } from './colorPropsSDKFactoryBuilder';
export const createFillColorPropsSDKFactory = buildColorPropsSDKFactoryCreator('fillColor');
//# sourceMappingURL=fillColorPropsSDKFactory.js.map